/**
 * Model Price API client (Settings → Project → Model prices).
 *
 * Reads (list/metrics) need APP_VIEW; writes need CONFIG_MODEL_PRICES_MANAGE.
 * The panels gate their edit controls on that permission so members don't hit
 * a 403 after filling in a form.
 *
 * team_id is passed explicitly on every call: the axios interceptor only
 * auto-attaches X-Team-Id for /boards and /chat URLs, and the backend verifies
 * the caller's membership against the resolved team for both reads and writes.
 */
import axiosInstance from 'shared/services/api/axiosInstance';

const BASE = '/config/model-prices';

export async function listModelPrices(teamId) {
  const { data } = await axiosInstance.get(BASE, { params: { team_id: teamId } });
  return data?.prices || [];
}

export async function createModelPrice(teamId, payload) {
  const { data } = await axiosInstance.post(BASE, { ...payload, team_id: teamId });
  return data; // { price, warnings }
}

export async function updateModelPrice(teamId, id, payload) {
  const { data } = await axiosInstance.patch(`${BASE}/${id}`, { ...payload, team_id: teamId });
  return data; // { price, warnings }
}

export async function deleteModelPrice(teamId, id) {
  const { data } = await axiosInstance.delete(`${BASE}/${id}`, { params: { team_id: teamId } });
  return data;
}

export async function fetchModelMetrics(teamId, model, { from, to } = {}) {
  const { data } = await axiosInstance.get(`${BASE}/metrics`, {
    params: { team_id: teamId, model, from, to },
  });
  return data; // { model, from, to, bucket_seconds, summary, buckets }
}

export async function mergeModelPrice(teamId, targetId, source) {
  const { data } = await axiosInstance.post(`${BASE}/merge`, {
    team_id: teamId, target_id: targetId, source,
  });
  return data; // { price }
}
